
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/universities",
      function () {
        return require("private-next-pages/universities.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/universities"])
      });
    }
  